module.exports = __webpack_public_path__ + "static/media/file.4eafe556.png";